import { StarbaseEntity, Serializable } from 'starbase-launcher';
import { ImageFile } from './imageFile';
import { IColumnModel, ColumnModel } from 'table-editor';
import { ITableColumn, TableColumn, ColumnDataTypes, DropdownTableColumn, ColumnDropdownData } from 'new-table-editor';

export enum RelatedSetTypeEnum {
  GENERAL = 0,
  LEDGER = 1
}

export class SelectableSetType{
  selected: boolean;
  key: string;
  value: number;
}

export class RelatedSetModel extends StarbaseEntity implements Serializable<RelatedSetModel> {
    private static selectTypeEnum: SelectableSetType[] = [{key: 'General', selected: false , value:0},{key: 'Ledger', selected: false, value: 1}]

    public uid: number;
    public name: string;
    public description: string;
    public isOrdnanceReturnSet: boolean; //This one matters, linking model ordnanceSet doesnt, we will use this going forward.
    public setType: RelatedSetTypeEnum;
    public imagesInSet: number;
    public images: ImageFile[];
    public imageUIDs?: number[];

    public get typeDisp(): SelectableSetType {
        const typeDisp = {
            selected: true,
            key: this.setType == RelatedSetTypeEnum.GENERAL ? 'GENERAL' : 'LEDGER',
            value: this.setType
        };
        return typeDisp;
    }


    //DO NOT REMOVE NEEDED TO FUNCTION
    public set typeDisp(a : any){

    }

    constructor() {
        super(0);
    }

    public static relatedImageSetColumnData(editable: boolean = false): IColumnModel[] {
        return [
            new ColumnModel('Set Name', 'name', 'name', editable, 'string', false, false, 150, false),
            new ColumnModel('Description', 'description', 'description', editable, 'string', false, false, 250, false),
            new ColumnModel('Ordnance Return Set', 'isOrdnanceReturnSet', 'isOrdnanceReturnSet', editable, 'boolean', false, false, 10, false),
            new ColumnModel('Type', 'setType', 'setType', editable, 'dropdown', false, false, 100, false),
            new ColumnModel('Images Count', 'imagesInSet', 'imagesInSet', false, 'number', false, false, 50, false),
            new ColumnModel('Created By', 'createdByUser', 'createdByUser', false, 'string', false, false, 100, false),
            new ColumnModel('Created Date/Time', 'createdDateTime', 'createdDateTime', false, 'date', false, false, 100, false),
        ];
    }

    public static relatedImageSetColumns(): ITableColumn[] {
        const nameCol = new TableColumn('name', 'Set Name', ColumnDataTypes.string, true, true, true);
        nameCol.sortingColumn = 'Name';
        const descCol = new TableColumn('description', 'Description', ColumnDataTypes.string, true, true, false);
        descCol.sortingColumn = 'Description';
        const ordCol = new TableColumn('isOrdnanceReturnSet', 'Ordnance Return Set', ColumnDataTypes.yesno, true, true, false);
        ordCol.sortingColumn = 'isOrdnanceReturnSet';
        const imgsCol = new TableColumn('imagesInSet', '# Images in Set', ColumnDataTypes.number, true, false, false);
        imgsCol.sortingColumn = 'ImagesInSet';
        const typeCol = new DropdownTableColumn(
            'typeDisp',
            'Type',
            'setType',
            new ColumnDropdownData(this.selectTypeEnum),
            true,
            true,
            false);
        typeCol.dropdownData.setup('key', 'value');
        typeCol.sortingColumn = 'setType';
        return [
            nameCol,
            descCol,
            ordCol,
            imgsCol,
            typeCol,
            ...TableColumn.generateColumnsForStarbaseEntity(false, false, true)
        ];
    }

    public static sequenceNumberColumnData(): IColumnModel[] {
        return [
            new ColumnModel('Set Name', 'name', 'name', false, 'string', false, false, 150, false),
            new ColumnModel('Sequence Number', 'sequenceNumber', 'sequenceNumber', true, 'number', false, false, 10, false),
            new ColumnModel('Created By', 'createdByUser', 'createdByUser', false, 'string', false, false, 100, false),
            new ColumnModel('Created Date/Time', 'createdDateTime', 'createdDateTime', false, 'date', false, false, 100, false),
        ];
    }

    deserialize(input) {
      return Object.assign(new RelatedSetModel(), input);
    }
}
